export default "__VITE_ASSET__df398ef0__"